export default __webpack_public_path__ + "assets/images/994d0ec96dfee029aa3f74e639ad3999.png";